import Application from './apppplication-controller'
import withI18next from '../../i18n/with-i18next'

// wrapping application with i18next provider
export default withI18next()(Application)
